import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';

export function SaveButton({ content, onClick, disabled }) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      title={content}
      startIcon={<FontAwesomeIcon icon={faSave} />}
      variant="outlined"
      size="small"
    >
      {content}
    </Button>
  );
}

SaveButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

SaveButton.defaultProps = {
  onClick: () => null,
  content: 'Записати',
  disabled: false,
};

export default SaveButton;
